import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()

export class NavigationService {
  infrastructure() {
    this.router.navigate(['/infrastructure'])
  }

  constructor(private router: Router) {
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  goToUnAuthorized() {
    this.router.navigate(['/unauthorized']);
  }

  goTOMiPage() {
    this.router.navigate(['/ribbion']);
  }

  goTOMiDashboard() {
    this.router.navigate(['/minewdashboard']);
  }

  goToSessionTimedOut() {
    this.router.navigate(['/sessiontimedout']);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === '/login';
  }

  goToUser(id: number, actionInfo: number) {
    this.router.navigate(['/users/' + id, actionInfo]);
  }

  goToProfile(id: number, actionInfo: number) {
    this.router.navigate(['/profile/' + id, actionInfo]);
  }

  goToDistrict(id: number, actionInfo: number) {
    this.router.navigate(['/district/' + id, actionInfo]);
  }

  goToBlock(id: number, actionInfo: number) {
    this.router.navigate(['/block/' + id, actionInfo]);
  }

  goToSector(id: number, actionInfo: number) {
    this.router.navigate(['/sector/' + id, actionInfo]);
  }

  goToAwc(id: number, actionInfo: number) {
    this.router.navigate(['/awc/' + id, actionInfo]);
  }

  goToAwcPage() {
    this.router.navigate(['/awc/']);
  }
  
  gotoadduser() {
    this.router.navigate(['/adduser']);
  }
  library() {
    this.router.navigate(['/library/']);

  }
  editaddpage(id: number, actionInfo: number) {
    console.log(id, actionInfo, "actionInfoactionInfoactionInfo");

    this.router.navigate(['/library/' + id, actionInfo]);

  }
  goTomem()
  {
    this.router.navigate(['/members']);

  }
  gotoaddpage()
  {
    this.router.navigate(['/addlibrary']);

  }
  editmemberaddpage(id: number, actionInfo: number) {
    console.log(id, actionInfo, "actionInfoactionInfoactionInfo");

    this.router.navigate(['/members/' + id, actionInfo]);

  }
  gotomemberaddpage()
  {
    this.router.navigate(['/member']);

  }
  userpage() {
    this.router.navigate(['/employee']);
  }
 
  report(){
    this.router.navigate(['/reports'])
  }
  editadduserpage(id: number, actionInfo: number)
  {
    console.log(id, actionInfo, "actionInfoactionInfoactionInfo");

    this.router.navigate(['/employee/' + id, actionInfo]);
  }
  memberreport(){
    this.router.navigate(['/memberreport'])
  }
  libraryreport(){
    this.router.navigate(['/libraryreport'])
  }
  attendancereport(){
    this.router.navigate(['/attendancereport'])
  }

}


